import { useEffect, useState } from "react";
import Modal from "./Modal";
import { BtnGeneral } from "../../styles/Buttons";
import { transformarGrupos } from "../../utils/groupTransform";
import { getActiveGroups, postActiveGroups } from "../../api/ActiveGroupApi";
import { usePatientData } from "../../context/PatientDataContext";

const ActiveGroupModal = ({ isOpen, tipo_id, Identificacion, onClose }) => {
  const [grupos, setGrupos] = useState([]);
  const [grupoActivo, setGrupoActivo] = useState(null);
  const [searchGrupo, setSearchGrupo] = useState("");
  const [selecciones, setSelecciones] = useState({});
  const [activoBase, setActivoBase] = useState({});
  const [loading, setLoading] = useState(false);
  const [fechaInicio, setFechaInicio] = useState(
    new Date().toISOString().split("T")[0]
  );
  const { fetchPatientData } = usePatientData();

  useEffect(() => {
    if (!isOpen) {
      setSearchGrupo("");
      return;
    }
    if (!tipo_id || !Identificacion) return;

    loadActiveGrups();
  }, [isOpen, tipo_id, Identificacion]);

  useEffect(() => {
    setFechaInicio("");
  }, [grupoActivo]);

  const loadActiveGrups = async (keepGrupoId = null) => {
    try {
      setLoading(true);

      const rs = await getActiveGroups(tipo_id, Identificacion);

      const data = transformarGrupos(rs);

      setGrupos(data);

      if (keepGrupoId && data.some((g) => g.id === keepGrupoId)) {
        setGrupoActivo(keepGrupoId);
      } else {
        setGrupoActivo(data[0]?.id || null);
      }

      const seleccionInicial = {};
      const activosDesdeBase = {};

      data.forEach((grupo) => {
        const activo = grupo.subgrupos.find((s) => s.activo);
        if (activo) {
          seleccionInicial[grupo.id] = activo.id;
          activosDesdeBase[grupo.id] = activo.id;
        }
      });

      setSelecciones(seleccionInicial);
      setActivoBase(activosDesdeBase);
    } catch (error) {
      console.error("Error cargando grupos", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSubgrupo = (grupoId, subId) => {
    setSelecciones((prev) => ({
      ...prev,
      [grupoId]: subId,
    }));
  };

  const handleAceptar = async () => {

    const subgrupoSeleccionado = selecciones[grupoActivo];
    if (!subgrupoSeleccionado) return;
    const activo = activoBase[grupoActivo] === subgrupoSeleccionado;

    if (activo) return;

    const payload = {
      idGrupo: grupoActivo,
      idSubgrupo: subgrupoSeleccionado,
      activar: 1,
      tipoId: tipo_id,
      num_id: Identificacion,
      fecha: fechaInicio
    };

    await postActiveGroups(payload);
    fetchPatientData();
    loadActiveGrups(grupoActivo);
  };

  const handleSacarSubgrupo = async () => {
    const subgrupoBase = activoBase[grupoActivo];
    if (!subgrupoBase) return;

    const payload = {
      idGrupo: grupoActivo,
      idSubgrupo: subgrupoBase,
      activar: 0,
      tipoId: tipo_id,
      num_id: Identificacion,
      fecha: null
    };

    await postActiveGroups(payload);
    fetchPatientData();
    loadActiveGrups(grupoActivo);
  };

  const grupoSeleccionado = grupos.find((g) => g.id === grupoActivo);
  const gruposFiltrados = grupos.filter((g) =>
    (g.nombre?.toLowerCase() || "").includes(searchGrupo.trim().toLowerCase())
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Menú de Grupos"
      width="800px"
    >
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div
          style={{
            display: "flex",
            gap: "20px",
            maxHeight: "70vh",
            minHeight: 0,
          }}
        >
          {/* ===== COLUMNA GRUPOS ===== */}
          <div
            style={{
              width: "35%",
              borderRight: "1px solid #ddd",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "6px",
              }}
            >
              <h5 style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>Grupos</h5>
              {searchGrupo && (
                <span style={{ fontSize: "11px", color: "#64748b" }}>
                  {gruposFiltrados.length} de {grupos.length}
                </span>
              )}
            </div>

            <div style={{ position: "relative", marginBottom: "6px", paddingRight: "8px" }}>
              <input
                type="text"
                placeholder="Buscar grupo..."
                value={searchGrupo}
                onChange={(e) => setSearchGrupo(e.target.value)}
                style={{
                  width: "100%",
                  height: "26px",
                  padding: "2px 22px 2px 8px",
                  fontSize: "11.5px",
                  borderRadius: "5px",
                  border: "1px solid #cbd5e1",
                  outline: "none",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                }}
              />
              {searchGrupo && (
                <button
                  type="button"
                  onClick={() => setSearchGrupo("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "#94a3b8",
                    cursor: "pointer",
                    fontSize: "11px",
                    padding: "2px",
                    lineHeight: 1,
                  }}
                  title="Limpiar búsqueda"
                >
                  ✕
                </button>
              )}
            </div>

            <div
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                paddingRight: "8px",
              }}
            >
              {gruposFiltrados.length > 0 ? (
                gruposFiltrados.map((grupo) => (
                  <div
                    key={grupo.id}
                    onClick={() => setGrupoActivo(grupo.id)}
                    style={{
                      padding: "2px 6px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      marginBottom: "1px",
                      fontSize: "12px",
                      lineHeight: "1.3",
                      background: grupoActivo === grupo.id ? "#e0f2fe" : "transparent",
                      color: grupoActivo === grupo.id ? "#0284c7" : "#334155",
                      fontWeight: grupoActivo === grupo.id ? "600" : "normal",
                      transition: "background 0.15s ease",
                    }}
                  >
                    {grupo.nombre}
                  </div>
                ))
              ) : (
                <div style={{ padding: "8px 4px", fontSize: "11.5px", color: "#94a3b8", textAlign: "center" }}>
                  {searchGrupo ? "No se encontraron grupos" : "No hay grupos"}
                </div>
              )}
            </div>
          </div>

          {/* ===== COLUMNA SUBGRUPOS ===== */}
          <div
            style={{
              width: "65%",
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 style={{ margin: 0 }}>Subgrupos</h5>

              <div style={{ display: "flex", gap: "8px" }}>
                {activoBase[grupoActivo] && (
                  <BtnGeneral
                    bg="gray"
                    padding="7px"
                    radius="8px"
                    onClick={handleSacarSubgrupo}
                  >
                    Sacar del Subgrupo
                  </BtnGeneral>
                )}

                <BtnGeneral
                  bg="green"
                  padding="7px"
                  radius="8px"
                  onClick={handleAceptar}
                  disabled={!selecciones[grupoActivo]}
                >
                  Incluir en Subgrupo
                </BtnGeneral>
              </div>
            </div>
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "5px"
              }}>
              <label style={{ fontSize: "12px", color: "#666" }}>
                Fecha Inicio de la Condición
              </label>
              <input
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                style={{
                  display: "block",
                  fontSize: "13px",
                  marginTop: "2px"
                }}
              />
            </div>

            {!grupoSeleccionado && <p>Seleccione un grupo</p>}

            <div
              style={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                paddingRight: "8px",
              }}
            >
              {grupoSeleccionado?.subgrupos.map((sub) => (
                <label
                  key={sub.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "8px",
                  }}
                >
                  <input
                    type="radio"
                    name={`grupo-${grupoSeleccionado.id}`}
                    checked={selecciones[grupoSeleccionado.id] === sub.id}
                    onChange={() =>
                      handleSelectSubgrupo(grupoSeleccionado.id, sub.id)
                    }
                  />
                  {sub.nombre}
                </label>
              ))}
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ActiveGroupModal;
